import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from 'app/content/helpers/date';

@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDatePipe implements PipeTransform {
    transform(date: string, format = 'DD.MM.YYYY'): string {
        return formatDate(date, format);
    }
}
